import React, { useEffect, useRef, useState } from "react";

// Chapter divider, connects major sections like turning a page.
export const Chapter = ({ number, title }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const io = new IntersectionObserver(
      ([e]) => e.isIntersecting && (setInView(true), io.disconnect()),
      { threshold: 0.6 }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} data-testid={`chapter-${number}`} className="relative bg-[#08080a] py-10 lg:py-14 overflow-hidden" aria-hidden="true">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center gap-6">
        <span className={`font-heavy text-5xl lg:text-7xl leading-none transition-all duration-1000 ${inView ? "text-[#F5D000]/20 translate-y-0" : "text-transparent translate-y-4"}`}>
          {number}
        </span>
        <div className="flex-1 flex items-center gap-5">
          <span className={`h-px bg-gradient-to-r from-[#F5D000]/60 to-transparent transition-all duration-[1200ms] ease-out ${inView ? "flex-1" : "w-0"}`} />
          <span className={`text-[10px] uppercase tracking-[0.35em] whitespace-nowrap transition-opacity duration-1000 delay-300 ${inView ? "opacity-100 text-white/40" : "opacity-0"}`}>
            {title}
          </span>
        </div>
      </div>
    </div>
  );
};

// Thin reading-progress thread at the very top of the experience.
export const ScrollThread = () => {
  const barRef = useRef(null);
  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const h = document.documentElement.scrollHeight - window.innerHeight;
        if (barRef.current) barRef.current.style.transform = `scaleX(${h > 0 ? window.scrollY / h : 0})`;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf); };
  }, []);
  return (
    <div data-testid="ri-scroll-thread" className="fixed top-0 left-0 right-0 h-[3px] z-[60] bg-transparent pointer-events-none">
      <div ref={barRef} className="h-full w-full bg-[#F5D000] origin-left will-change-transform" style={{ transform: "scaleX(0)" }} />
    </div>
  );
};
